import React from "react";
import {CSSProperties, FunctionComponent} from 'react';
import {ClipLoader} from "react-spinners";

interface LoadingProps{
    loading: boolean;
}

const Loading: FunctionComponent<LoadingProps> = (
    {
        loading
    }
) => {

    const style: CSSProperties = {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 100,
    };

    if (!loading) return null;

    return (
        <div style={style}>
            <div className={'align-middle text-costcenter'}>
                <ClipLoader
                    size={50}
                    color={'#0B4B78'}
                    loading={loading}
                />
            </div>
        </div>
    );
};

export default Loading;
